import React from 'react';
import {observer} from 'mobx-react';
import ModalSimple from '../../../global/modal-simple';
import * as util from '../../../util';
import s from '../../s';

declare var __company_name: string;
declare var __domain_name: string;

@observer
class SmartBoxModal extends React.Component {
    render() {
        return (
            <>
                <button
                    className="link link-btn"
                    onClick={() => util.modal('modal-smart-box')}
                    aria-label="Open information about SMARTbox package"
                    type="button"
                    aria-haspopup="dialog"
                    aria-controls="modal-smart-box"
                >
                    SMARTbox package
                </button>

                <ModalSimple
                    id="modal-smart-box"
                    title="SMARTbox Package Information"
                >
                    <div>
                        <p>
                            The <strong>SMARTbox</strong> is a cutting-edge packaging solution designed to make receiving, managing, and transporting your diploma frame as seamless as possible. Introduced by {__company_name}, this innovative ship-ready box combines durability and functionality,
                            ensuring your frame arrives in pristine condition. With a built-in carry handle, the SMARTbox offers convenience for walk-out sales and easy transportation, making it perfect for both customers and retailers.
                        </p>
                        <p>
                            Available for over 95% of our diploma frame sizes and styles, the SMARTbox is more than just packaging—it's a streamlined solution for previewing frames, inventory management, and secure shipping. Whether you're purchasing a frame for yourself or as a gift, the SMARTbox
                            ensures a professional and hassle-free experience from start to finish.
                        </p>

                        <picture>
                            <source
                                srcSet={`https://${s.Portal.CDNDomain}/images/cached/general/smartbox_1024.webp`}
                                type="image/webp"
                            />
                            <img
                                className="resp"
                                src={`https://${s.Portal.CDNDomain}/images/cached/general/smartbox_1024.jpg`}
                                alt="SMARTbox shipping container with carry handle"
                                width="300"
                            />
                        </picture>

                        <div style={{marginTop: '1rem'}}>
                            <a
                                href="/customer-service/shipping-information/smartbox"
                                className="link underline"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="View SMARTbox package information"
                            >
                                SMARTbox package
                            </a>
                        </div>
                    </div>
                </ModalSimple>
            </>
        );
    }
}

export default SmartBoxModal;
